import type { CartItem } from '../store/cart.store';
import type { ProductSearchResult } from '../services/products/products.service';

const WHATSAPP_NUMBER = '573193650538';

export function openWhatsAppProduct(producto: ProductSearchResult, presentacion?: { id: string; nombre: string; precio: number }) {
  const nombre = producto.nombre;
  const presentacionNombre = presentacion?.nombre || producto.presentaciones?.[0]?.nombre || '';
  const precio = presentacion?.precio || producto.presentaciones?.[0]?.precio || 0;
  const receta = producto.requiereReceta ? 'Sí' : 'No';

  const mensaje = encodeURIComponent(
    `¡Hola!\n\n` +
    `Me interesa el siguiente producto:\n\n` +
    `*Producto:* ${nombre}\n` +
    `${presentacionNombre ? `*Presentación:* ${presentacionNombre}\n` : ''}` +
    `*Precio:* $${precio.toLocaleString()}\n` +
    `${producto.requiereReceta ? `*Requiere receta:* Sí\n` : ''}` +
    `\n¿Podrían confirmarme si está disponible? Gracias.`
  );

  window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${mensaje}`, '_blank');
}

export function openWhatsAppCart(items: CartItem[]) {
  if (items.length === 0) return;

  const subtotal = items.reduce((total, item) => total + item.precio * item.cantidad, 0);
  const envio = subtotal >= 50000 ? 0 : 5000;
  const total = subtotal + envio;

  let productosTexto = '';
  items.forEach((item, index) => {
    const presentacion = item.presentacionNombre ? ` - ${item.presentacionNombre}` : '';
    const cantidad = item.cantidad > 1 ? ` x${item.cantidad}` : '';
    productosTexto += `${index + 1}. *${item.nombre}*${presentacion}${cantidad} - $${(item.precio * item.cantidad).toLocaleString()}\n`;
  });

  const mensaje = encodeURIComponent(
    `¡Hola!\n\n` +
    `Quisiera hacer el siguiente pedido:\n\n` +
    `${productosTexto}\n` +
    `*Subtotal:* $${subtotal.toLocaleString()}\n` +
    `*Envío:* ${envio === 0 ? 'GRATIS' : `$${envio.toLocaleString()}`}\n` +
    `*Total:* $${total.toLocaleString()}\n\n` +
    `Por favor confirmen disponibilidad y forma de pago. Gracias.`
  );

  window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${mensaje}`, '_blank');
}
